import React, { ReactNode, useEffect, useRef, useState } from 'react';
type DeferredSectionProps = {
  children: ReactNode;
  minHeight: string;
};
export function DeferredSection({
  children,
  minHeight
}: DeferredSectionProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    if (!('IntersectionObserver' in window)) {
      setIsReady(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      setIsReady(true);
      observer.disconnect();
    }, {
      rootMargin: '900px 0px'
    });
    observer.observe(container);
    return () => observer.disconnect();
  }, []);
  return <div ref={containerRef} style={{
    minHeight: isReady ? undefined : minHeight
  }} aria-busy={!isReady} data-id="element-136" data-mp="2mp3dcut5t7py">
      {isReady ? children : null}
    </div>;
}